// Path helper for the public /free-ads-audit on-page experience.

export const FREE_ADS_AUDIT_PATH = '/free-ads-audit'
